import "./FloatingDropdownWithIcon.css";
import { useEffect, useRef, useState } from "react";
import Arrow from "../../../../assets/images/rightAnglePath.svg";
import dropdownAngle from "../../../../assets/images/dropdownAngle.svg";
import CheckIcon from "../../../../assets/images/greenCheck.svg";
import CircleIcon from "../../../../assets/images/grayCircle.svg";


const FloatingDropdownWithIcon = ({
  className = "",
  id,
  label,
  options,
  selectedValues = [],
  disabled = false,
  setSelectedValues,
  showLabelAnimation = false,
  focusedAllowed = true,
  onDropdownClose,
  filtertradeId=null,
  bgWhite=false,
  filterTime=null,
  onSelectedBgTrue=false


}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [internalOptions, setInternalOptions] = useState([]);

  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setInternalOptions(
      options.map((opt) => ({
        ...opt,
        checked: selectedValues.some((sel) => sel.key === opt.key),
      }))
    );
  }, [options, selectedValues]);
  useEffect(()=>{
    if(filtertradeId){
      setInternalOptions(options.map(el=>{
        if(el._id===filtertradeId){
          el.checked=true
          // setSelectedValues([el]);
        }
        return el;
      }))
    }else if(filterTime){
      setInternalOptions(options.map(el=>{
        if(el.updateTime===filterTime){
          el.checked=true
        }
        return el;
      }))
    }
  },[filtertradeId,options])
  const handleDropdownToggle = () => setIsOpen((prevState) => !prevState);
  const handleOptionToggle = (option) => {
    const updatedOptions = internalOptions.map((opt) =>
      opt.key === option.key ? { ...opt, checked: !opt.checked } : opt
    );
    setInternalOptions(updatedOptions);
    const selected = updatedOptions.filter((opt) => opt.checked);
    setSelectedValues(selected);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
        if (onDropdownClose) {
          const selected = internalOptions.filter((opt) => opt.checked);
          onDropdownClose(selected);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [internalOptions, onDropdownClose]);

  return (
    <div
      className={`form-floating customDropdownComponent ${className}`}
      ref={dropdownRef}
    >
      <button
        className={`dropdownButton ${isOpen ? "active" : ""} ${
          selectedValues.length && focusedAllowed
            ? "has-value"
            : selectedValues.length
            ? "has-white-background"
            : ""
        }  ${bgWhite&&isOpen?"bg-white":""}`}
        onClick={handleDropdownToggle}
        ref={buttonRef}
        disabled={disabled}
      >
        <span
          className={`dropdown-selected ${
            !selectedValues.length ? "placeholder" : ""
          } ${showLabelAnimation ? "animation_text_field" : ""}`}
        >
          {selectedValues.length
            ? selectedValues.map((v) => v.symbol || v.label).join(", ")
            : label}
        </span>
        <span
          className={`dropdownArrow ${isOpen && "rotate"}`}
          style={{ opacity: selectedValues.length >0 && 1 }}
        >
          <img alt="" src={dropdownAngle} />
        </span>
      </button>
      {showLabelAnimation && (
        <label
          className={`floating-label ${
            isOpen || selectedValues.length ? "active" : ""
          }`}
          htmlFor={id}
        >
          {label}
        </label>
      )}
      {/* {!selectedValues.length && !showLabelAnimation && (
        <label
          className={`floating-label ${
            isOpen || selectedValues.length ? "activeLabel" : ""
          }`}
          htmlFor={id}
        >
          {label}
        </label>
      )} */}
      {isOpen && (
        <div className="IcondropdownContent">
          {internalOptions.map((option, index) => {
            const label = option.symbol || option.label;
            const checked = option.checked;
            return (
              <p
                className="dropdown-option d-flex"
                key={index}
                onClick={() => handleOptionToggle(option)}
              >
                <span className="arrowspan checkIcon">
                  <img
                    alt={checked ? "Checked" : "Circle"}
                    src={checked ? CheckIcon : CircleIcon}
                    style={{ width: 20, height: 20 }}
                  />
                </span>
                <span className="span1 coinName text-truncate">{label}</span>
                <div className="d-flex" style={{marginLeft: '22px', gap: 15}}>
                <span className="span1">{Number(option.roiPercentage||0)?.toFixed(2)}%</span>
                <span className="span1">${Number((option?.realizedPnl||option?.pnl)||0).toFixed(2)}</span>
                </div>
              </p>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FloatingDropdownWithIcon;
